class Store {
  constructor() {
    this.data = {
      onUpdate: null,
      error: null,
      successMsg: null,
    };
  }

  setFailure(e) {
    this.data.error = e;
    this.save();
  }

  setSuccess(msg) {
    this.data.successMsg = msg;
    this.save();
  }

  onUpdate(func) {
    this.data.onUpdate = func;
  }

  save() {
    if (!this.data.onUpdate) {
      return;
    }
    this.data.onUpdate();
    return true;
  }
}

export default new Store();
